module.exports = __webpack_public_path__ + "img/8.41d00b20.webp";